export default __webpack_public_path__ + "static/media/background-562x312.790a6073.jpeg";